import React from "react";

import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";
import { useGetCategoriesQuery } from "../api/Get";

export default function useGetCategoryHook() {
    const { showNotification } = useUtilitiesContext();

    const {
        data: categories,
        isError: isCategoriesError,
        error: categoriesError,
        isFetching: isCategoriesFetching,
        refetch: refetchCategories
    } = useGetCategoriesQuery();

    React.useEffect(() => {
        if (isCategoriesError) {
            showNotification({
                type: "error",
                title: "Error",
                message: categoriesError.message,
            });
        }
    }, [isCategoriesError, categoriesError, showNotification]);

    return {
        categories,
        isCategoriesFetching,
        refetchCategories
    };
}